<template>
  <div class="fc-top" @contextmenu.prevent.stop>
    <div class="tabList">
      <span
        class="tabItem"
        :class="{ curStyle: item.id == curId }"
        v-for="(item, index) in tabList"
        :key="index"
        @click="setNav(item)"
        >{{ $t(item.name) }}</span
      >
    </div>
    <div class="search-box">
      <el-input
        :disabled="disabled"
        v-model="keyword"
        :placeholder="placeholder"
        @keyup.enter.native="toSearch"
      >
        <svg-btn
          v-show="keyword != ''"
          @click="clearValue()"
          slot="suffix"
          icon-class="icon-ipt-clear"
        ></svg-btn>
        <svg-btn
          @click="search()"
          slot="suffix"
          icon-class="icon-ipt-search"
        ></svg-btn>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    curId: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabList: [
        { id: 0, name: "shortChain.shortLink", url: '/shortChain' },
        { id: 1, name: "shortChain.statsDashboard", url: "/setRecycle" },
      ],
      keyword: "",
    };
  },
  created() {},
  methods: {
    setNav(item) {
      if(item.id == 1){
        const url = process.env.VUE_APP_DAREN_URL + '/shortlink'
        window.open(url, "_blank");
        return
      }
      this.$router.push({
        path: item.url,
      });
    },
    search() {
      //if (this.keyword == "") {
      //  return;
      //}
      this.$emit("searchList", this.keyword);
    },
    clearValue() {
      this.keyword = "";
      this.$emit("searchList", this.keyword);
    },
    toSearch() {
      this.$emit("searchList", this.keyword);
    },
  },
};
</script>
